import { render, staticRenderFns } from "./DirModelForm.vue?vue&type=template&id=7507d850&scoped=true&"
import script from "./DirModelForm.vue?vue&type=script&lang=js&"
export * from "./DirModelForm.vue?vue&type=script&lang=js&"
import style0 from "./DirModelForm.vue?vue&type=style&index=0&id=7507d850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7507d850",
  null
  
)

export default component.exports